import { getRailsEnv } from '@opendoor/shared-fe/build/railsEnv';

const railsEnv = getRailsEnv();

export const WEB_URL = {
  production: 'https://opendoor.com',
  staging: 'https://demo.simplersell.com',
  development: process.env.LOCAL_WEB ? 'http://localhost:3011' : 'https://demo.simplersell.com',
  test: 'https://demo.simplersell.com',
  qa: 'https://demo.simplersell.com',
}[railsEnv];

export const IS_PROD = railsEnv === 'production';

export const LOGIN_URL = `${WEB_URL}/login`;

export const MapboxApiKey = process.env.REACT_APP_MAPBOX_API_KEY;

export const OPENDOOR_HQ = 'a6442419-0651-4ea6-8ea9-d7bd8b8414e2';
export const HOME_OPS_TRIPPY_DOMAIN = 'c74e89da-6c91-4ccf-af57-83c69a793edf';
export const DAY_ONE_WALK_PARTNERS_NATIONAL_BRANCH_ID = '121e5871-a924-4a37-a93b-3751c80e3498';
